import dateFns from 'date-fns';

import { checkEmailValidity } from '../../Core/utilities/checkEmailValidity';
/**
 * Joins an array of string tags into a single string
 *
 * @param {Array} array An array of strings we want to join
 * @returns {String} The joined string
 */
export const createTagsString = array => {
  return array.join(',');
};

export const emailErrorMessages = {
  invalidAddress: 'Email must be valid',
  duplicateAddress: "A contact with this email address already exists for this contact's owner.",
};

export const relationErrorMessage = '* Required field - You can create more relationship types on your settings page';
export const primaryEmailLabel = 'Primary Email';
export const secondaryEmailLabel = 'Secondary Email';
export const spouseEmailLabel = 'Spouse Email';
export const typeRelationLabel = 'Type of Relation';

/**
 * Checks if the emails are valid.
 * If there is an error, set the focus to the input field and display the corresponding
 * error message.
 * @param {String} primaryEmail the email address entered
 * @param {String} secondaryEmail the secondary email address entered
 * @param {Object} primaryEmailField primary email field component
 * @param {Object} secondaryEmailField secondary email field component
 */
export function validateEmails(
  component,
  primaryEmail,
  secondaryEmail,
  spouseEmail,
  primaryEmailField,
  secondaryEmailField,
  spouseEmailField,
) {
  if (secondaryEmail && !checkEmailValidity(secondaryEmail) && secondaryEmailField) {
    secondaryEmailField.focus();
    component.fieldValueErrorTypes.push(secondaryEmailLabel);
    component.fieldValueErrorMessages[secondaryEmailLabel] = emailErrorMessages.invalidAddress;
  }
  if (primaryEmail && !checkEmailValidity(primaryEmail) && primaryEmailField) {
    primaryEmailField.focus();
    component.fieldValueErrorTypes.push(primaryEmailLabel);
    component.fieldValueErrorMessages[primaryEmailLabel] = emailErrorMessages.invalidAddress;
  }
  if (spouseEmail && !checkEmailValidity(spouseEmail)) {
    let field = null;
    if(spouseEmailField) {
      field = spouseEmailField[0] || spouseEmailField;
    }
    if(field) field.focus();
    component.fieldValueErrorTypes.push(spouseEmailLabel);
    component.fieldValueErrorMessages[spouseEmailLabel] = emailErrorMessages.invalidAddress;
  }
}

export function validateRelation(
  component,
  relation,
  relationField,
) {
  if (!relation) {
    relationField.focus();
    component.fieldValueErrorTypes.push(typeRelationLabel);
    component.fieldValueErrorMessages[typeRelationLabel] = relationErrorMessage;
  }
}

export const DefaultSlippingAwayDays = 7;

export function generateSlippingAwayConditions(days = DefaultSlippingAwayDays) {
  const currentTime = new Date();
  const startOfToday = dateFns.startOfDay(currentTime);
  const slippingAwayTimestamp = Math.floor(
    dateFns.subDays(startOfToday, parseInt(days, 10)) / 1000,
  );
  return [
    {
      last_activity_at: { $lt: slippingAwayTimestamp },
    },
    {
      last_site_visit_at: { $lt: slippingAwayTimestamp },
    },
    {
      last_user_login_at: { $lt: slippingAwayTimestamp },
    },
    {
      last_search_performed_at: { $lt: slippingAwayTimestamp },
    },
    {
      last_saved_search_added_at: { $lt: slippingAwayTimestamp },
    },
    {
      last_saved_search_removed_at: { $lt: slippingAwayTimestamp },
    },
    {
      last_property_viewed_at: { $lt: slippingAwayTimestamp },
    },
    {
      last_favorite_property_added_at: { $lt: slippingAwayTimestamp },
    },
    {
      last_favorite_property_removed_at: { $lt: slippingAwayTimestamp },
    },
    {
      created_at: { $lt: slippingAwayTimestamp },
    },
  ];
}

export function timeBetweenDates(startDate, endDate) {
  const second = 1000;
  const minute = 60;
  const hour = 3600;
  const day = 86400;

  const delta = Math.abs(startDate - endDate) / second;
  const totalMinutes = Math.floor(delta / minute);
  const totalHours = Math.floor(delta / hour);
  const totalDays = Math.floor(delta / day);
  
  const isDays = totalDays >= 1;
  const isMinutes = totalMinutes <= 60;
  const isHours = totalHours > 0 && totalHours <= 24;
  
  let time = '';
  let unitTime = '';

  if (isMinutes) {
    time = totalMinutes;
    unitTime = 'minutes';
  }
  if (isHours) {
    time = totalHours;
    unitTime = 'hours';
  }
  if (isDays) {
    time = totalDays;
    unitTime = 'days';
  }
  return `${time} ${unitTime}`
}
